<template>
  <div class="pl-8 pr-3 w-full h-full">
    <h1 class="text-sm text-white font-bold">Tools</h1>
    <div class="py-3">
      <div class="w-full mb-1">
        <label class="text-xs text-white">Map <i>(pilih salah satu)</i></label>
        <ul class="py-1">
          <li class="px-3 py-3 mb-1 flex gap-2 justify-start items-center bg-gray-100">
            <input
              @change="selectToolMap('distance', $event)"
              :checked="tools.map.distance"
              type="checkbox">
            <span class="text-xs text-stone-900">Hitung jarak</span>
          </li>
        </ul>
      </div>
      <div class="w-full mb-1">
        <label class="text-xs text-white">Pelaporan <i>(manajemen laporan)</i></label>
        <ul class="py-1">
          <li
            @click="openCapture()"
            class="px-3 py-3 mb-1 flex gap-2 justify-start items-center bg-gray-100 hover:bg-gray-300 cursor-pointer">
            <i class="material-icons text-lg text-blue-500">add_a_photo</i>
            <span class="text-xs text-stone-900">Capture map</span>
          </li>
          <li
            @click="setActiveSubMenu('ToolReports')"
            class="px-3 py-3 mb-1 flex gap-2 justify-start items-center bg-gray-100 hover:bg-gray-300 cursor-pointer">
            <i class="material-icons text-lg text-blue-500">list_alt</i>
            <span class="text-xs text-stone-900">List laporan</span>
          </li>
        </ul>
      </div>
      <div class="w-full mb-1">
        <label class="text-xs text-white">Zona <i>(manajemen data spasial)</i></label>
        <ul class="py-1">
          <li
            @click="setActiveSubMenu('ToolZones')"
            class="px-3 py-3 mb-1 flex gap-2 justify-start items-center bg-gray-100 hover:bg-gray-300 cursor-pointer">
            <i class="material-icons text-lg text-blue-500">share_location</i>
            <span class="text-xs text-stone-900">Buat zona</span>
          </li>
          <li
            @click="setActiveSubMenu('ToolZoneShow')"
            class="px-3 py-3 mb-1 flex gap-2 justify-start items-center bg-gray-100 hover:bg-gray-300 cursor-pointer">
            <i class="material-icons text-lg text-blue-500">preview</i>
            <span class="text-xs text-stone-900">Tampilan zona</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ToolMain',
  computed: {
    ...mapGetters(['tools'])
  },
  methods: {
    ...mapActions([
      'toChangeCursor',
      'toChangeLayerOSM'
    ]),
    ...mapMutations([
      'setToolMap',
      'setActiveSubMenu'
    ]),
    selectToolMap: function (toolName, e) {
      this.setToolMap({
        name: toolName,
        status: e.target.checked
      })

      if (e.target.checked) {
        this.toChangeCursor('crosshair')
      } else {
        this.toChangeCursor('grab')
      }
    },
    openCapture: function () {
      this.toChangeLayerOSM()
      this.setActiveSubMenu('ToolCaptureShoot')
    }
  }
}
</script>
